import React from "react";
import { Table } from "semantic-ui-react";

export const watercraftContent = (
  <Table className={"coverage-area-table"}>
    <Table.Body>
      <Table.Row>
        <Table.HeaderCell colSpan={3}>Watercraft</Table.HeaderCell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>
          <Table className={"coverage-area-inner-table"}>
            <Table.Body>
              <Table.Row>
                <Table.Cell className={"red-text"}>State</Table.Cell>
                <Table.Cell className={"red-text"}>Start Date</Table.Cell>
                <Table.Cell className={"red-text"}> End Date</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Alaska</Table.Cell>
                <Table.Cell>1970</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Arizona</Table.Cell>
                <Table.Cell>2000</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Arkansas</Table.Cell>
                <Table.Cell>1998</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Colorado</Table.Cell>
                <Table.Cell>1998</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Connecticut</Table.Cell>
                <Table.Cell>1991</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Florida</Table.Cell>
                <Table.Cell>1997</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Georgia</Table.Cell>
                <Table.Cell>1977</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Illinois*</Table.Cell>
                <Table.Cell>2001</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Iowa</Table.Cell>
                <Table.Cell>1999</Table.Cell>
                <Table.Cell>Mar-10</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Kansas</Table.Cell>
                <Table.Cell>2003</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Kentucky</Table.Cell>
                <Table.Cell>2004</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Maine</Table.Cell>
                <Table.Cell>1989</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Maryland*</Table.Cell>
                <Table.Cell>2004</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Massachusetts</Table.Cell>
                <Table.Cell>2000</Table.Cell>
                <Table.Cell>2002</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Michigan</Table.Cell>
                <Table.Cell>2002</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Minnesota</Table.Cell>
                <Table.Cell>1985</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Mississippi</Table.Cell>
                <Table.Cell>2001</Table.Cell>
                <Table.Cell>2006</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Missouri</Table.Cell>
                <Table.Cell>1986</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Montana*</Table.Cell>
                <Table.Cell>1970</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Nebraska</Table.Cell>
                <Table.Cell>2001</Table.Cell>
                <Table.Cell>2009</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Nevada</Table.Cell>
                <Table.Cell>1970</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>New Hampshire*</Table.Cell>
                <Table.Cell>2002</Table.Cell>
                <Table.Cell>2011</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>New York*</Table.Cell>
                <Table.Cell>1997</Table.Cell>
                <Table.Cell>2000</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>North Carolina*</Table.Cell>
                <Table.Cell>1977</Table.Cell>
                <Table.Cell>2011</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>North Dakota</Table.Cell>
                <Table.Cell>2001</Table.Cell>
                <Table.Cell>2008</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Ohio</Table.Cell>
                <Table.Cell>2001</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>South Carolina*</Table.Cell>
                <Table.Cell>1970</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Tennessee*</Table.Cell>
                <Table.Cell>1974</Table.Cell>
                <Table.Cell>2002</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Texas</Table.Cell>
                <Table.Cell>1975</Table.Cell>
                <Table.Cell>2002</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Utah*</Table.Cell>
                <Table.Cell>1983</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Virginia</Table.Cell>
                <Table.Cell>N/A</Table.Cell>
                <Table.Cell>N/A</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Washington</Table.Cell>
                <Table.Cell>1977</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>West Virginia</Table.Cell>
                <Table.Cell>2010</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Wisconsin</Table.Cell>
                <Table.Cell>1995</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Wyoming*</Table.Cell>
                <Table.Cell>1998</Table.Cell>
                <Table.Cell>Current</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>U.S Coast Guard Merchant Vessels</Table.Cell>
                <Table.Cell>1998</Table.Cell>
                <Table.Cell>2009</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell colSpan={3} className={"red-text"}>
          * Only historical data available
        </Table.Cell>
      </Table.Row>
    </Table.Body>
  </Table>
);

export default watercraftContent;



// WEBPACK FOOTER //
// ./src/components/coveragearea/Watercraft.js